import { getLocale, getLocaleOverride } from '@eventbrite/i18n';
import pickBy from 'lodash/pickBy';
import { StatsigConf } from '../models/statsig';
import { TicketsPageSize } from '../models/ticketsPage';
import { CheckoutState } from '../state';
import { WithAppNamespace } from '../state/app';

export const getDefaultUserCountry = (state: CheckoutState): string =>
    state.app.defaultUserCountry;

export const getEbDomain = (state: CheckoutState) => state.app?.ebDomain;

export const getActiveFFsFromCore = ({ app }: CheckoutState) => {
    return Object.keys(
        pickBy(app.featureFlags, (value: any) =>
            typeof value === 'object' ? value.isActive : !!value,
        ),
    ).sort();
};

export const getFeatureFlags = ({ app }: CheckoutState) => ({
    featureFlags: app.featureFlags,
});

export const getLocaleProps = ({ app, event }: CheckoutState) => {
    return {
        locales: app.locales,
        defaultLocale:
            getLocaleOverride() ??
            getLocale({
                eventLocale:
                    ('properties' in event && event.properties.locale) || '',
                appLocale: app.locale,
            }),
    };
};
//TODO To change after Redux initialization refactor - EB-214132
export const isEventbriteTLD = (state: CheckoutState | StatsigConf): boolean =>
    'app' in state ? state.app.isEventbriteTLD : state.isEventbriteTLD;
export const getGooglePayEnvironment = (state: CheckoutState) => {
    return state.app.isProd ? 'PRODUCTION' : 'TEST';
};

export const getCurrencyFormat = (state: CheckoutState) =>
    state.app.currencyFormat;

export const getIsRegEvent = (state: CheckoutState) => state.app.isRegEvent;

export const getIsTicketSelectionCompactSizeFlow = (
    state: CheckoutState,
): boolean =>
    state.app?.request?.params?.ticketsPageSize === TicketsPageSize.compact;

export const getEnablePaymentConstraintsInNewCreate = (state: CheckoutState) =>
    Boolean(state.app.featureFlags?.enablePaymentConstraintsInNewCreate);

export const getIsProd = (state: CheckoutState) => Boolean(state.app.isProd);

export const isIosApp = <State extends WithAppNamespace>(
    state: State,
): boolean => state.app.useIosProfile;

export const isAndroidApp = <State extends WithAppNamespace>(
    state: State,
): boolean => state.app.useAndroidProfile;

export const isNativeApp = <State extends WithAppNamespace>(
    state: State,
): boolean => !!(state.app.useIosProfile || state.app.useAndroidProfile);

export const hasFewTicketsLeftUrgencySignal = (state: CheckoutState) =>
    !!state.app.urgencySignals?.messages.fewTickets;

export const hasSalesEndSoonUrgencySignal = (state: CheckoutState) =>
    !!state.app.urgencySignals?.messages.salesEndSoon;

export const getCorrelationId = (state: CheckoutState) =>
    state.app.request.correlation_id;

export const getSessionId = (state: CheckoutState) =>
    state.app.request.session_id;
